/**
 * Utility for post module
 */
import * as _ from "lodash";
export const utilPostService = {
  getContactTypes,
  checkGroupId,
  getAttrFromString,
};

/**
 * Get selected contact types from list
 * return comman seprated string of contact types
 */
function getContactTypes(contactTypes) {
  let contactTypeList = contactTypes;

  let selected_contact_types_string = "";

  // find selected contact types from list
  let selected_contact_types = contactTypeList.filter((e) => e.isChecked);

  if (selected_contact_types && selected_contact_types.length > 0) {
    selected_contact_types_string = selected_contact_types_string + " (";
    selected_contact_types.forEach((item, index) => {
      selected_contact_types_string =
        selected_contact_types_string + item.value;
      if (selected_contact_types.length - 1 !== index) {
        selected_contact_types_string = selected_contact_types_string + ",";
      }
    });
    selected_contact_types_string = selected_contact_types_string + ")";
  }

  return selected_contact_types_string;
}
/**
 * find group id in list of groups
 * @param {*} id
 */
function checkGroupId(id) {
  let obj = _.find(this.state.noticeData.group_list.groups, { groupUid: id });
  if (obj) {
    return true;
  } else {
    return false;
  }
}

/**
 * Summary. Function used to find image tag and src attribute from content_html.
 * @param {*} str  content html string
 * @param {*} node tage (img)
 * @param {*} attr attriubte (src)
 */
function getAttrFromString(str, node, attr, style) {
  // let regex = new RegExp('<' + node + ' .*?' + attr + '="(.*?)" />', "gi"),
  //   result, res = [];
  let regex = new RegExp(
      "<" + node + " .*?" + attr + '="(.*?)"' + " .*?" + ">",
      "gi"
    ),
    result,
    res = [];
  if (style) {
    regex = new RegExp(
      "<" + node + " .*?" + attr + '="(.*?)" ' + style + '="(.*?)" />',
      "gi"
    );
  }
  while ((result = regex.exec(str))) {
    var obj = {};
    obj["tag"] = result[0];
    obj["key"] = result[1];
    if (style) {
      obj["style"] = result[2];
    }
    res.push(obj);
  }
  return res;
}
